var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44650_10817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53101 7.65625C8.63194 8.40324 9.19272 9.06574 10 9.37875C10.8073 9.06578 11.3681 8.40328 11.4691 7.65625H8.53101Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4691 12.3438C11.3681 11.5968 10.8073 10.9343 10 10.6213C9.19272 10.9343 8.63194 11.5968 8.53101 12.3438H11.4691Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5144 6.48438H11.4853V5.51281C11.0179 5.3577 10.5185 5.27344 9.99983 5.27344C9.48112 5.27344 8.98175 5.3577 8.5144 5.51281V6.48438Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3427 12.5864C7.3427 11.5678 7.8652 10.6215 8.71344 10.0001C7.8652 9.37861 7.3427 8.43236 7.3427 7.41369V6.09326C6.09453 6.9449 5.27344 8.37834 5.27344 10.0001C5.27344 11.6218 6.09453 13.0552 7.3427 13.9069V12.5864Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7551 10C18.7551 9.29254 18.6706 8.60492 18.5122 7.94609L19.7494 6.88656L17.571 3.11344L16.0333 3.65566C15.0407 2.71148 13.8267 1.99828 12.4773 1.6009L12.1784 0H7.8215L7.5226 1.6009C6.17322 1.99828 4.95916 2.71148 3.96662 3.65566L2.42889 3.11344L0.250488 6.88656L1.48768 7.94609C1.32928 8.60492 1.24479 9.29258 1.24479 10C1.24479 10.7074 1.32928 11.3951 1.48768 12.0539L0.250488 13.1134L2.42893 16.8866L3.96666 16.3443C4.9592 17.2885 6.17326 18.0017 7.52264 18.3991L7.8215 20H12.1783L12.4772 18.3991C13.8266 18.0017 15.0407 17.2885 16.0332 16.3443L17.571 16.8866L19.7494 13.1134L18.5122 12.0539C18.6706 11.3951 18.7551 10.7075 18.7551 10ZM9.99994 15.8984C6.74752 15.8984 4.1015 13.2524 4.1015 10C4.1015 6.74758 6.74752 4.10156 9.99994 4.10156C13.2524 4.10156 15.8984 6.74758 15.8984 10C15.8984 13.2524 13.2524 15.8984 9.99994 15.8984Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6574 6.09326V7.41369C12.6574 8.43236 12.1349 9.37861 11.2866 10.0001C12.1349 10.6215 12.6574 11.5678 12.6574 12.5864V13.9069C13.9055 13.0552 14.7266 11.6218 14.7266 10.0001C14.7266 8.37834 13.9055 6.9449 12.6574 6.09326Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4853 13.5156H8.5144V14.4872C8.98179 14.6423 9.48112 14.7266 9.99987 14.7266C10.5186 14.7266 11.018 14.6423 11.4853 14.4872V13.5156Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44650_10817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt);
export default __webpack_public_path__ + "static/media/ct.3f738251c47578365b2a07efbc273ddc.svg";
export { ForwardRef as ReactComponent };